import React from 'react';
import { InView } from 'react-intersection-observer';

import StoryItem from '@components/RelatedStories/StoryItem';
import useEventTracking from '@hooks/useEventTracking';
import { Article } from '@interfaces/homepage';
import { ImpressionElement, TrackingLocation, impression } from '@tracking';

import { PeriodOption } from '../types';

interface MostReadArticlesProps {
  articles: Article[];
  selectedPeriod: PeriodOption;
}

const MostReadArticles = ({ articles, selectedPeriod }: MostReadArticlesProps) => {
  const { Track, trackEvent } = useEventTracking({
    location: TrackingLocation.MostPopularArticles,
  });

  if (articles.length === 0) {
    return null;
  }

  return (
    <Track>
      <InView
        triggerOnce={true}
        onChange={(inView) => {
          inView &&
            trackEvent(impression({ impressionElement: ImpressionElement.MostPopularArticles }));
        }}
      >
        <section className="mt-28 border-0 border-t border-solid border-t-grayscale-beige pt-28">
          <h3 className="m-0 font-suisse-intl text-overline-md font-normal text-black">
            Most read articles, {selectedPeriod.label.toLowerCase()}
          </h3>
          <div className="mt-28 grid grid-cols-1 gap-x-28 gap-y-64 sm:grid-cols-2 md:grid-cols-3">
            {articles.map((article) => (
              <StoryItem key={article.id} {...article} withCopyOption />
            ))}
          </div>
        </section>
      </InView>
    </Track>
  );
};

export default MostReadArticles;
